import { Observable, tap } from "rxjs";

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "../../services/authservice";
import { ErrorRouter } from "./error-router";

@Injectable()
export class NWDHttpInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);
  private router = inject(Router);

  private errorRouter = inject(ErrorRouter);

  private excludedPages = ["/forbidden", "/error", "/notfound", "/support", "/news"];

  private isExcludedPage(url: string) {
    return this.excludedPages.some((p) => url.includes(p));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only add Authorization header here if not already present
    if (!request.headers.has("Authorization")) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.userToken()}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap({
        error: (err: unknown) => {
          if (err instanceof HttpErrorResponse) {
            if (request.headers.get("x-ignore-interceptor") === "1") {
              return;
            }
            const page = this.router.routerState.snapshot.url;

            if (this.isExcludedPage(request.url) || this.isExcludedPage(page)) {
              return;
            }

            this.errorRouter.redirect(request.url, err.status);
          }
        },
      }),
    );
  }
}
